import { render } from "./charts_cons.vue?vue&type=template&id=97bb1dcc"
import script from "./charts_cons.vue?vue&type=script&lang=js"
export * from "./charts_cons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__